import type { ReactNode } from "react";
import styles from "./Grid.module.css";

type SpaceToken = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

interface GridProps {
  readonly columns?: number;
  readonly minChildWidth?: string;
  readonly gap?: SpaceToken;
  readonly children: ReactNode;
  readonly className?: string;
}

export function Grid({
  columns,
  minChildWidth,
  gap = 6,
  children,
  className,
}: GridProps) {
  const templateColumns = columns
    ? `repeat(${columns}, 1fr)`
    : `repeat(auto-fit, minmax(${minChildWidth ?? "280px"}, 1fr))`;

  return (
    <div
      className={`${styles.grid} ${className ?? ""}`}
      style={{
        gridTemplateColumns: templateColumns,
        gap: `var(--space-${gap})`,
      }}
    >
      {children}
    </div>
  );
}
